<template>
  <h2 class="text-3xl font-bold text-center text-indigo-900 mb-12">SchoolMeet.AI</h2>
  <div id="login-screen"
    class="p-8 rounded-2xl bg-white shadow max-w-sm w-full mx-auto"
    v-if="!isLoggedIn">

    <h2 class="text-2xl font-bold text-black mb-6">Login</h2>
    <form id="login-form" @submit.prevent="handleLogin">

      <div class="mb-6">
        <label for="email" class="block text-gray-700 font-medium mb-2">Email</label>
        <input v-model="email" type="text"
          class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Email" required />
      </div>
      <div class="relative mb-6">
        <label for="password" class="block text-gray-700 font-medium mb-2">Password</label>
        <input v-model="password" :type="passwordVisible ? 'text' : 'password'"
          class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Password" required />
          <span class="absolute inset-y-0 right-0 top-8 flex items-center px-4 text-gray-600"
            @click="togglePasswordVisibility">
            <template v-if="passwordVisible">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                stroke="currentColor" class="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            </template>
            <template v-else>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                stroke="currentColor" class="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round"
                  d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </template>
          </span>
      </div>
      <button type="submit"
        class="w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
        <span v-if="!isFetching">Login</span>

        <svg v-if="isFetching" aria-hidden="true" role="status" class="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"></path>
    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="#1C64F2"></path>
    </svg>
      </button>


    </form>
    <p v-if="errorMessage" class="text-red-500 mt-4 text-center">{{ errorMessage }}</p>
  <div class="text-center pt-8">
    <router-link to="/auth/passwordReset">Forgot Password?</router-link>
  </div> 
  </div>

  <div id="otp-screen" class="bg-white p-8 rounded-2xl border border-gray-200 max-w-sm w-full mx-auto my-16" v-else>
    <h2 class="text-2xl font-bold text-center text-gray-800 mb-6">OTP</h2>
    <form id="otp-form" @submit.prevent="handleOtp">
      <div class="mb-6">
        <label for="otp" class="block text-gray-700 font-medium mb-2">One time password</label>
        <input type="text" id="otp" v-model="otp"
          class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0000" required />
      </div>
      <button type="submit"
        class="w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
        Approve
      </button>
    </form>
    <p v-if="otpErrorMessage" class="text-red-500 mt-4 text-center">{{ otpErrorMessage }}</p>
  </div>

</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import apiClient from '@/axios';
import { toast } from 'vue3-toastify';
import { useAuthStore } from '../../stores/auth';

export default defineComponent({
  name: 'LoginView',
  components: {
  },
  setup() {
    const isFetching = ref<boolean>(false);
    const router = useRouter();
    const authStore = useAuthStore();
    const email = ref('');
    const password = ref('');
    const passwordVisible = ref<boolean>(false);
    const otp = ref('');
    const isLoggedIn = ref(false);
    const errorMessage = ref('');
    const otpErrorMessage = ref('');

    const dummyCredentials = {
      otp: '0000',
    };

    const handleLogin = async () => {
      isFetching.value = true;
      try {
        const response = await apiClient.post('/auth/login', {
          email: email.value,
          password: password.value,
        });
        if (response.data.success === false) {
          toast.error(response.data.message);
          isFetching.value = false;
          return;
        }
        const { token, user, school } = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('school', JSON.stringify(school));
        localStorage.setItem('isAuthenticated', 'true');

        if (user.role === 'Parent') {
          router.push('/parent');
        } else {
          router.push('/');
        }

      } catch (error) {
        errorMessage.value = 'Login failed. Please check your credentials.';
      }
      isFetching.value = false;
    };

    const handleOtp = () => {
      if (otp.value === dummyCredentials.otp) {
        authStore.login();
        router.push('/');
      } else {
        otpErrorMessage.value = 'Invalid OTP';
      }
    };

    const togglePasswordVisibility = () => {
      passwordVisible.value = !passwordVisible.value;
    };

    return {
      togglePasswordVisibility,
      passwordVisible,
      email,
      password,
      otp,
      isLoggedIn,
      errorMessage,
      otpErrorMessage,
      handleLogin,
      handleOtp,
      isFetching,
    };
  },
});
</script>

<style scoped>
/* İsteğe bağlı ek stil tanımları */
</style>
